__webpack_require__.p = "https://oneclicksecret.archeredu.com/";